import styled from 'styled-components';

import { media } from '../../../utils/mediaQueries';

export const MobileTrialBarWrapper = styled.div`
    display: none;

    ${media.tabletDown} {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 50;
        height: 40px;
        background: linear-gradient(135deg, #103433 0%, #0a2322 100%);
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
        align-items: center;
        justify-content: center;
        padding: 0 12px;
    }
`;

export const TrialBadge = styled.div<{ $urgency?: 'normal' | 'warning' | 'critical' }>`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 6px;
    background: ${({ $urgency }) => {
    if ($urgency === 'critical') return 'rgba(239, 68, 68, 0.25)';
    if ($urgency === 'warning') return 'rgba(234, 148, 54, 0.25)';
    return 'rgba(255, 255, 255, 0.1)';
  }};
    border: 1px solid ${({ $urgency }) => {
    if ($urgency === 'critical') return 'rgba(239, 68, 68, 0.4)';
    if ($urgency === 'warning') return 'rgba(234, 148, 54, 0.4)';
    return 'rgba(255, 255, 255, 0.15)';
  }};
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: ${({ $urgency }) => {
    if ($urgency === 'critical') return 'rgba(239, 68, 68, 0.35)';
    if ($urgency === 'warning') return 'rgba(234, 148, 54, 0.35)';
    return 'rgba(255, 255, 255, 0.15)';
  }};
    }

    &:active {
        transform: scale(0.98);
    }

    ${media.mobile} {
        padding: 3px 10px;
        gap: 5px;
    }
`;

export const TrialLabel = styled.span<{ $urgency?: 'normal' | 'warning' | 'critical' }>`
    font-size: 11px;
    font-weight: 500;
    color: ${({ $urgency }) => {
    if ($urgency === 'critical') return '#fca5a5';
    if ($urgency === 'warning') return '#fdba74';
    return 'rgba(255, 255, 255, 0.85)';
  }};
    line-height: 1.2;

    ${media.mobile} {
        font-size: 10px;
    }
`;

export const TrialCountdown = styled.span<{ $urgency?: 'normal' | 'warning' | 'critical' }>`
    font-size: 11px;
    font-weight: 400;
    color: ${({ $urgency }) => {
    if ($urgency === 'critical') return '#fca5a5';
    if ($urgency === 'warning') return '#fdba74';
    return '#ffffff';
  }};
    line-height: 1.2;

    ${media.mobile} {
        font-size: 10px;
    }
`;
